<template>
    <div class="offer-info">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div>
            <div v-if="offerInfo.accepted.counter_offer_status !== 4">
                <p class="offer-title">Artist Offer</p>
                <div class="payout-info-wrapper">
                    <p class="payout-information">
                        {{ payoutCalculated(offerInfo.propose.payout) }}
                    </p>
                    <p class="fee-information">
                        {{ feeInformation(offerInfo.propose.payout) }}
                    </p>
                </div>
                <p class="available-info">Proposed Set {{ offerInfo.availability }}</p>
                <p v-if="offerInfo.propose.message" class="messages">
                    "{{ offerInfo.propose.message }}"
                </p>
                <div v-if="!artistBooked && !counterOffer" class="btn-container">
                    <button v-b-modal.modal-payment class="accept-btn">Accept</button>
                    <button class="accept-btn" @click="counterOffer = !counterOffer">
                        Counter
                    </button>
                    <button
                        v-if="counterOfferData.venue_subscription === 'VenuePremium'"
                        class="accept-btn"
                        @click="() => sendPayment(true)"
                    >
                        Pay Later
                    </button>
                    <button class="decline-btn" @click="goToChat">Message</button>
                    <button class="decline-btn" @click="declineArtist">Decline</button>
                </div>
            </div>
            <div v-if="offerInfo.accepted.counter_offer_status === 4">
                <p class="offer-title">Artist Offer</p>
                <div class="payout-info-wrapper">
                    <p class="payout-information">
                        {{ payoutCalculated(offerInfo.accepted.payout) }}
                    </p>
                    <p class="fee-information">
                        {{ feeInformation(offerInfo.accepted.payout) }}
                    </p>
                </div>
                <p v-if="offerInfo.accepted.message" class="messages">
                    "{{ offerInfo.accepted.message }}"
                </p>
                <div v-if="!artistBooked && !counterOffer" class="btn-container">
                    <button v-b-modal.modal-payment class="accept-btn">Accept</button>
                </div>
            </div>
            <div v-if="artistBooked">
                <p class="artist-booked-title">Artist Booked!</p>
                <p class="artist-booked-text">
                    Awesome! We’ll let Artist Name know you’ve accepted their offer.
                </p>
                <button @click="backToBookingManage" class="back-to-booking">
                    Back to Booking Manager
                </button>
            </div>
            <div v-if="counterOffer">
                <p class="artist-booked-title">Counter Offer</p>
                <div class="d-flex">
                    <div class="proposed-payout me-3">
                        <p>Proposed Payout *</p>
                        <input
                            placeholder="Eg. $100"
                            @input="formattedPayout"
                            v-model="proposedPayout"
                        />
                        <p v-if="proposedPayoutError" class="error-text">
                            {{ proposedPayoutError }}
                        </p>
                    </div>
                    <div class="proposed-payout position-relative">
                        <p>Proposed Set Length *</p>
                        <input
                            placeholder="Eg. 10 min"
                            type="text"
                            v-model="proposedSetLength"
                            maxlength="4"
                            @input="numericInput"
                            :class="{
                                'border-error': proposedSetLengthError.length
                            }"
                        />
                        <p class="duration-hours" v-if="!proposedSetLengthError">
                            {{ getDurationHours }}
                        </p>
                        <p v-if="proposedSetLengthError" class="error-text">
                            {{ proposedSetLengthError }}
                        </p>
                    </div>
                </div>
                <div class="proposed-payout">
                    <p>Message</p>
                    <input
                        placeholder="Eg. $100"
                        v-model="proposedMessage"
                        :class="{ 'massage-field': width < 600 }"
                    />
                    <p v-if="proposedMessageError" class="error-text">
                        {{ proposedMessageError }}
                    </p>
                </div>
                <div class="d-flex mt-5">
                    <button
                        @click="submitCounterOffer"
                        class="back-to-booking"
                        :disabled="!getButtonActive"
                        :class="{ 'disabled-class': !getButtonActive }"
                    >
                        {{ width > 600 ? 'Submit Counter Offer' : 'Submit' }}
                    </button>
                    <button @click="counterOffer = !counterOffer" class="cancel-btn">
                        Cancel
                    </button>
                </div>
            </div>
            <hr style="background: #8b8b8b" />
        </div>
        <b-modal
            no-enforce-focus
            content-class="modal-payout-offer"
            id="modal-payment"
            size="lg"
            hide-footer
            centered
        >
            <template #modal-header>
                <div class="header-container">
                    <p class="modal-payout-title">Book the Artist</p>
                    <div class="modal-event-info">
                        <div class="modal-artist-info">
                            <div class="row-name">Artist</div>
                            <div class="row-value">{{ artistName }}</div>
                        </div>
                        <hr class="divider" />
                        <div class="modal-artist-info">
                            <div class="row-name">Event Date</div>
                            <div class="row-value-add">{{ eventDate }}</div>
                        </div>
                        <hr class="divider" />
                        <div class="modal-artist-info">
                            <div class="row-name">Set Start Time</div>
                            <div class="row-value-add">
                                {{ offerInfo.propose.start_avail }}
                            </div>
                        </div>
                        <hr class="divider" />
                        <div class="modal-artist-info">
                            <div class="row-name">Set Length</div>
                            <div class="row-value-add">
                                {{
                                    parseInt(
                                        Math.round(parseFloat(offerInfo.propose.duration) * 60)
                                    )
                                }}
                                min
                            </div>
                        </div>
                        <hr class="divider" />
                        <div class="modal-artist-info flex-column">
                            <div class="total-payment">
                                <div class="row-name">You Pay</div>
                                <div class="row-value">${{ vanuePays }}</div>
                            </div>
                            <ul class="payment-info-row">
                                <li>
                                    <div class="payout-info">
                                        <div class="artist-gets">Artist Fees</div>
                                        <div class="artist-gets-payout">
                                            ${{ actualPayout }}
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="payout-info">
                                        <div class="artist-gets">Hedlyner Fees</div>
                                        <div class="artist-gets-payout">
                                            ${{ hedlinerFeesAmount }}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
            <div class="d-flex flex-column modal-wrapper">
                <!--                <p class="payment-title">Activate your free trial</p>-->
                <div>
                    <!--                    <p class="payment-description">
                        Now let’s add payment details to share your event with the talent pool
                    </p>
                    <p class="payment-description">
                        Experience Hedlyner risk-free with our one-month free trial! Unlock
                        premium premium features, explore a diverse range of talented artists
                        or invite your favorites. Start transforming your live music bookings
                        today!
                    </p>-->
                </div>
                <PaymentFields
                    :startDate="this.offerInfo.start_date"
                    :startTime="this.offerInfo.start_time"
                    :duration="this.offerInfo.duration"
                    :cardStripeId.sync="cardStripeId"
                    :address="this.offerInfo.event_location"
                    :isClickedCard="isClickedCard"
                    :bidArtist="bidArtist"
                    :eventId="eventId"
                    :paymentMethods.sync="paymentMethods"
                    :artistBooked.sync="artistBooked"
                    @addNewCard="disabledBtn"
                    v-if="showPaymentFields"
                />
                <div class="agree-policy-main">
                    <div>
                        <input
                            type="radio"
                            name="agreeCheck"
                            v-model="agreement"
                            @change="updateState"
                        />
                    </div>
                    <div>
                        <span class="agree-policy"
                            >By selecting “Book Artist” below, I agree to Hedlyner's Terms of
                            Service, Payment Terms, Refunds & Cancellation Policy, Dispute
                            Resolution Policy and Off-Platform Policy</span
                        >
                    </div>
                </div>
                <div class="btn-block">
                    <button
                        :class="{
                            'disabled-btn': disabledSaveBtn || addNewCard
                        }"
                        :disabled="disabledSaveBtn || addNewCard"
                        @click="() => sendPayment()"
                    >
                        Book Artist
                    </button>
                    <p class="cancel-bnt" @click="$bvModal.hide('modal-payment')">Cancel</p>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import PaymentFields from '../../../payment-methods/PaymentFields.vue'
    import { notification } from '../../../../helpers/notification'
    import useTimeSelector from '@/composables/useTimeSelector.js'
    import checkScreen from '../../../../mixins/check-screen'
    export default {
        name: 'ArtistOffer',
        mixins: [checkScreen],
        components: {
            PaymentFields
        },
        props: {
            bidArtist: {
                type: Number
            },
            eventId: {
                type: Number
            },
            venueId: {
                type: Number
            },
            artistBooked: {
                type: Boolean,
                default: false
            },
            cardStripeId: {
                type: Number
            },
            venueSubscription: {
                type: String
            },
            paymentMethods: {
                type: Array,
                required: true,
                default: () => []
            },
            counter: {
                type: Boolean,
                required: false,
                default: false
            },
            counterOfferData: {
                type: Object
            }
        },
        setup() {
            const { startTime, timeFormat, calculateEndTime } = useTimeSelector()

            return {
                startTime,
                timeFormat,
                calculateEndTime
            }
        },
        data: () => ({
            load: false,
            offerInfo: [],
            isClickedCash: false,
            isClickedCard: true,
            showPaymentFields: true,
            selectedCash: false,
            counterOffer: false,
            proposedPayout: '',
            proposedSetLength: '',
            proposedMessage: '',
            proposedPayoutError: '',
            proposedSetLengthError: '',
            proposedMessageError: '',
            addNewCard: false,
            agreement: false,
            artistName: '',
            eventDate: ''
        }),
        methods: {
            updateState() {
                this.agreement = !this.agreement
            },
            async goToChat() {
                const userId = this.offerInfo.artist_user_id

                try {
                    const response = await axios.get(
                        `/api/profile/mail-chat/chat/exist/${userId}`
                    )

                    if (response.data.exists) {
                        sessionStorage.setItem('recipient_id', userId)
                        window.open('/profile/mail-chat', '_blank')
                    } else {
                        await this.createChat(userId)
                    }
                } catch (error) {
                    console.error('Error checking chat:', error)
                }
            },

            async createChat(userId) {
                try {
                    let dateText = ''
                    if (this.offerInfo && this.offerInfo.start_date) {
                        const eventDate = new Date(this.offerInfo.start_date)
                        dateText = `${
                            eventDate.getMonth() + 1
                        }/${eventDate.getDate()}/${eventDate.getFullYear()}`
                    }

                    const response = await axios.post('/api/profile/mail-chat', {
                        recipient_id: userId,
                        message: `Inquiry for Opportunity on ${dateText}`
                    })

                    if (response.data.message === 'Message successfully sent') {
                        sessionStorage.setItem('recipient_id', userId)
                        window.open('/profile/mail-chat', '_blank')
                    }
                } catch (error) {
                    console.error('Error creating chat:', error)
                }
            },
            disabledBtn(newValue) {
                this.addNewCard = newValue
            },
            numericInput() {
                this.proposedSetLength = this.proposedSetLength.replace(/[^0-9.,]/g, '')
            },
            formattedPayout() {
                if (this.proposedPayout === null || isNaN(this.proposedPayout)) {
                    return ''
                }
                return (this.proposedPayout = '$' + this.proposedPayout)
            },
            async getArtistOffer() {
                const result = await axios.get('/api/artist-offer/' + this.bidArtist)
                this.offerInfo = result.data.data
                this.proposedSetLength = `${parseFloat(
                    parseFloat(this.offerInfo.propose.duration) * 60
                ).toFixed(0)}`
            },
            selectedCashMethod() {
                if (this.getSubscription) {
                    this.isClickedCash = true
                    this.isClickedCard = false
                    this.showPaymentFields = false
                    this.addNewCard = false
                }
            },
            selectedCardMethod() {
                if (this.getSubscription) {
                    this.showPaymentFields = true
                    this.isClickedCard = true
                    this.isClickedCash = false
                }
            },
            async sendPayment(cash = false) {
                this.load = true
                try {
                    let start = this.offerInfo.accepted.start_avail
                        ? this.offerInfo.accepted.start_avail
                        : this.offerInfo.propose.start_avail

                    if (start.length === 8 && start[0] === '0') {
                        start = start.slice(1)
                    }
                    const response = await axios.post(
                        '/events/manage/' + this.bidArtist + '/event',
                        {
                            artist_id: this.bidArtist,
                            venue_id: this.venueId,
                            price: cash ? 0 : this.vanuePays,
                            date: this.offerInfo.start_date,
                            start: start,
                            address: this.offerInfo.event_location,
                            duration: this.offerInfo.accepted.duration
                                ? this.offerInfo.accepted.duration
                                : this.offerInfo.propose.duration,
                            payment:
                                this.cardStripeId && this.isClickedCard && !cash
                                    ? this.cardStripeId
                                    : 'cash',
                            event_type: 1
                        }
                    )
                    notification('success', response.data.message)
                    this.$bvModal.hide('modal-payment')
                    window.location.reload()
                } catch (error) {
                    const errors = Object.keys(error.response.data.errors)
                    for (let i = 0, length = errors.length; i < length; i++) {
                        notification('error', error.response.data.errors[errors[i]][0])
                    }
                } finally {
                    this.load = false
                }
            },
            async declineArtist() {
                try {
                    await axios.put('/event/manage/' + this.bidArtist + '/decline')
                    window.location.reload()
                    // @TODO when all endpoints will be prepare initialize notification window
                    // notification(
                    //     'success',
                    //     'Artist request to event was declined successfully'
                    // )
                } catch (error) {
                    notification('error', error)
                }
            },
            backToBookingManage() {
                window.location.href = '/booking-manager'
            },
            async submitCounterOffer() {
                try {
                    const setLength = parseFloat(
                        parseInt(this.proposedSetLength) / 60
                    ).toFixed(2)

                    const response = await axios.put(
                        '/api/artist-offer/' + this.bidArtist + '/counter',
                        {
                            venue_id: this.venueId,
                            counter_offer_propose: this.proposedPayout,
                            counter_offer_duration: setLength,
                            counter_offer_message: this.proposedMessage
                        }
                    )
                    notification('success', response.data.message)
                    this.counterOffer = false
                    window.location.reload()
                } catch (error) {
                    if (error.response.data.errors.counter_offer_propose)
                        this.proposedPayoutError =
                            error.response.data.errors.counter_offer_propose[0]
                    if (error.response.data.errors.counter_offer_duration)
                        this.proposedSetLengthError =
                            error.response.data.errors.counter_offer_duration[0]
                    if (error.response.data.errors.counter_offer_message)
                        this.proposedMessageError =
                            error.response.data.errors.counter_offer_message[0]
                    notification('error', error.response.data.message)
                }
            }
        },
        computed: {
            actualPayout() {
                return this.offerInfo.accepted.payout
                    ? this.offerInfo.accepted.payout
                    : this.offerInfo.propose.payout
            },
            feeInformation(self) {
                return (payout) => {
                    if (self.proposedPayout) {
                        payout = parseFloat(self.proposedPayout.slice(1))
                    }
                    const hedlynerFee = payout * self.offerInfo.venue_fee
                    return `Hedlyner Fees: $${hedlynerFee}, Artist Fees: $${payout}`
                }
            },
            payoutCalculated(self) {
                return (payout) => {
                    if (self.proposedPayout) {
                        payout = parseFloat(self.proposedPayout.slice(1))
                    }
                    const hedlynerFee = payout * self.offerInfo.venue_fee
                    return `You Pay $${hedlynerFee + payout}`
                }
            },
            vanuePays() {
                return this.actualPayout + this.actualPayout * this.offerInfo.venue_fee
            },
            hedlinerFeesAmount() {
                return this.actualPayout * this.offerInfo.venue_fee
            },
            getSubscription() {
                return this.venueSubscription !== 'VenueFree'
            },
            getButtonActive() {
                return this.proposedPayout && this.proposedSetLength
            },
            getDurationHours() {
                if (!this.proposedSetLength.length) return ''
                return parseFloat(this.proposedSetLength) > 1 ? 'mins' : 'min'
            },
            getIcon() {
                return '/images/'
            },
            disabledSaveBtn() {
                return !(this.paymentMethods.length && this.agreement)
            }
        },
        watch: {
            proposedSetLength: function (duration) {
                if (parseInt(duration) < 10) {
                    this.proposedSetLengthError =
                        'The set length should be more than 10 minutes'
                }
                if (parseInt(duration) > 300) {
                    this.proposedSetLengthError = 'The set length should be more than 5 hours'
                }
                this.proposedSetLengthError = ''
            },
            counter: {
                handler: function (counter) {
                    if (counter) {
                        this.counterOffer = true
                    }
                },
                immediate: true
            }
        },
        async created() {
            await this.getArtistOffer()
            this.artistName = localStorage.getItem('artistName')
            this.eventDate = localStorage.getItem('eventDate')
        }
    }
</script>

<style>
    .modal-payout-offer {
        border-radius: 15px;
        background: #151517;
        padding: 48px 80px;
    }
    @media (max-width: 1000px) {
        .modal-payout-offer {
            padding: 0;
        }
    }
</style>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .agree-policy-main {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }
    input[type='radio'] {
        height: 20px;
        width: 20px;
        background: inherit;
        appearance: none;
        border: 1px solid #8b8b8b;
        border-radius: 50%;
        min-height: 0;
    }
    input[type='radio']:checked {
        accent-color: #cdeb09;
        appearance: auto;
    }
    li {
        list-style: square;
        color: #acacac;
    }
    .agree-policy {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .subscriptions-bnt {
        color: #acacac;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        cursor: pointer;
        text-decoration: none;
    }
    .payment-choose {
        color: #dedede;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .cash-payment {
        color: #dedede;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
        margin-bottom: 0;
        margin-top: 48px;
    }
    .unsubscribe-description {
        color: #acacac;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        margin: 0;
    }
    .header-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        width: 100%;
    }
    .modal-payout-title {
        color: #f5f5f5;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .modal-event-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }
    .modal-artist-info {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        width: 100%;
        gap: 8px;
    }
    .payment-info-row {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        color: #f5f5f5;
        padding-left: 20px;
    }
    .total-payment {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }
    .payout-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .row-name {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .row-value {
        color: #c9cd00;
        text-align: right;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .row-value-add {
        color: #f5f5f5;
        text-align: right;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .artist-gets {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .artist-gets-payout {
        color: #f5f5f5;
        text-align: right;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .disabled-class {
        opacity: 0.5;
    }
    .duration-hours {
        position: absolute;
        top: 58%;
        right: 10%;
    }
    .select {
        border-radius: 8px !important;
        background: #262626 !important;
    }
    .selected-methods {
        display: flex;
        padding: 12px 24px 12px 20px;
        align-items: center;
        gap: 9px;
        border-radius: 8px;
        background: transparent;
    }
    .error-text {
        color: #f03232 !important;
        margin: 5px 0 0 0;
    }
    .cancel-btn {
        padding: 7px 20px 10px 20px;
        border-radius: 100px;
        border: 1px solid #c9cd00;
        color: #c9cd00;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        background: transparent;
        flex: 0 1 24%;
    }
    .massage-field {
        min-width: 100% !important;
    }
    .proposed-payout {
        margin-top: 15px;
    }
    .proposed-payout p {
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .proposed-payout input {
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        padding: 12px 15px 15px 15px;
        color: #dedede;
        min-width: 50%;
    }
    .border-error {
        border: 1px solid #d52020 !important;
    }
    .back-to-booking {
        border-radius: 100px;
        border: 1px solid #c9cd00;
        background: #c9cd00;
        padding: 7px 30px 10px 30px;
        color: #262626;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        flex: 0 1 24%;
        margin-right: 10px;
    }
    .artist-booked-text {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .artist-booked-title {
        color: #c9cd00;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .divider {
        width: 100%;
        color: #646464;
    }
    .disabled-btn {
        background: #464646 !important;
        color: #8b8b8b !important;
    }
    .methods-name-selected {
        color: #ffffff;
        text-align: center;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 400;
        margin: 0;
        line-height: 30px;
    }
    .modal-wrapper {
        gap: 32px;
    }
    .btn-block {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
    }
    .btn-block button {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        width: 100%;
        border: 0;
    }
    .cancel-bnt {
        color: #8b8b8b;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss09' on, 'ss08' on, 'ss03' on, 'ss07' on, 'ss02' on;
        font-family: 'Studio Pro';
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-decoration-line: underline;
        cursor: pointer;
    }
    .methods-icon {
        max-width: 24px;
        max-height: 24px;
    }
    .methods-name {
        color: #8b8b8b;
        text-align: center;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 400;
        line-height: 30px;
        margin: 0;
    }
    .methods-block {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 12px;
        background: #333;
        max-width: 350px;
        padding: 4px;
        cursor: pointer;
    }
    .payment-description {
        color: #c4c4c4;
        text-align: center;
        font-size: 20px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 400;
        line-height: 30px;
    }
    .payment-title {
        color: #acacac;
        text-align: start;
        font-family: 'Instrument Sans';
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .decline-btn {
        padding: 7px 20px 10px 20px;
        border-radius: 100px;
        border: 1px solid #c9cd00;
        color: #c9cd00;
        font-size: 18px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        background: #262626;
    }
    .accept-btn {
        padding: 7px 20px 10px 20px;
        border-radius: 100px;
        border: 1px solid #c9cd00;
        background: #c9cd00;
        color: #262626;
        font-size: 18px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .btn-container {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
    }
    .messages {
        white-space: pre-line;
        color: #acacac;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .available-info {
        color: #c9cd00;
        font-size: 18px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .payout-info-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
        gap: 16px;
    }
    .fee-information {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .payout-information {
        color: #c9cd00;
        font-size: 44px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .offer-title {
        color: #acacac;
        font-size: 26px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .offer-info {
        border-radius: 15px;
        background: #262626;
        padding: 25px;
        display: flex;
        flex-direction: column;
        margin-top: 15px;
    }
    @media (max-width: 1000px) {
        .offer-info {
            margin: 15px 16px 0 16px;
            padding: 16px;
        }
        .payout-information {
            font-size: 32px;
        }
        .offer-title {
            font-size: 22px;
        }
        .available-info {
            font-size: 16px;
        }
        .artist-booked-title {
            font-size: 32px;
        }
        .proposed-payout input {
            max-width: 100px;
        }
        .cancel-btn {
            flex: 0 1 100%;
        }
        .back-to-booking {
            flex: 0 1 100%;
        }
        .accept-btn {
            font-size: 16px;
            width: 100%;
        }
        .btn-container {
            gap: 8px;
            flex-direction: column;
            width: 100%;
        }
        .decline-btn {
            font-size: 16px;
            width: 100%;
        }
    }
</style>
